import * as React from 'react';

import './Page.less';

const Content: React.FunctionComponent = ({ children }) => (
  <div className="page__content">{children}</div>
);

const LeftSide: React.FunctionComponent = ({ children }) => (
  <div className="page__left-side">{children}</div>
);

class Page extends React.PureComponent {
  static Content = Content;
  static LeftSide = LeftSide;

  render() {
    const { children } = this.props;
    return <div className="page">{children}</div>;
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page/Page.tsx